import ClientManagementContainer from './ClientManagementContainer';

export {
    ClientManagementContainer
};

export default ClientManagementContainer;
